import { useEffect, useRef } from 'react';
import { CircularProgress, Box, Typography } from '@mui/material';
import { DarkBox } from '@dispatch/web/ui';
import { useLocalSignUp } from '@dispatch/web/auth';
import { useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';

/**
 * Accept Invite Page
 * Handles the /accept-invite route for local account sign-up
 * Redirects to B2C sign-up flow with PKCE
 */
export function AcceptInvitePage() {
  const { startLocalSignUp } = useLocalSignUp();
  const { inProgress } = useMsal();
  const hasInitiated = useRef(false);

  useEffect(() => {
    // Only start sign-up if:
    // 1. We haven't already initiated it
    // 2. No other MSAL interaction is in progress
    if (!hasInitiated.current && inProgress === InteractionStatus.None) {
      hasInitiated.current = true;
      startLocalSignUp();
    }
  }, [startLocalSignUp, inProgress]);

  // Show loading state while redirect is happening
  return (
    <DarkBox
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        color: 'white',
      }}
    >
      <CircularProgress size="4em" thickness={2} color="inherit" />
      <Box sx={{ mt: 3 }}>
        <Typography variant="h6" align="center">
          Redirecting to registration...
        </Typography>
        <Typography variant="body2" align="center" sx={{ mt: 1, opacity: 0.8 }}>
          Please wait while we prepare your account setup
        </Typography>
      </Box>
    </DarkBox>
  );
}

export default AcceptInvitePage;
